<template>

    <div class="integration-mapping">

        <v-form
            ref="form"
            @submit="onSubmit"
            :disabled="is_view"
            @submit.prevent="onSubmit">

            <v-container fluid>

                <v-row v-if="!is_view">
                    <v-col class="d-flex justify-end">

                        <v-btn @click="onSetDefaultMapping()" small>
                            <span>Set Default</span>
                        </v-btn>

                        <v-btn @click="clearMapping()" small class="ml-2">
                            <span>Clear</span>
                        </v-btn>

                        <v-btn :disabled="isSaving" small type="submit" color="primary" class="ml-2">
                            <span v-if="isSaving">
                                <v-progress-circular
                                    indeterminate
                                    size="12"
                                    width="2"
                                    color="primary darken-3">
                                </v-progress-circular>
                                Saving..
                            </span>
                            <span v-else>Save</span>
                        </v-btn>
                    </v-col>
                </v-row>


                <v-col class="overflow-auto">
                    <table class="table table-mapping">
                        <thead>
                            <tr>
                                <th style="width: 260px;">
                                    <h5 class="subtitle-2">Product Field</h5>
                                </th>
                                <th colspan="3" class="bg-orange-panel">
                                    <h5 class="subtitle-2">Data Source</h5>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <FormField :mapping="formProductMappings.sku" />
                            <FormField :mapping="formProductMappings.name" />
                            <FormField :mapping="formProductMappings.boxes" />
                            <FormField :mapping="formProductMappings.itemType" />
                            <FormField :mapping="formProductMappings.boxQuantity" />
                            <FormField :mapping="formProductMappings.length" />
                            <FormField :mapping="formProductMappings.width" />
                            <FormField :mapping="formProductMappings.height" />
                            <FormField :mapping="formProductMappings.weight" />

                            <tr class="item-row-header mb-3" style="background-color: #fff8dc;">
                                <td colspan="5" class="pt-5">
                                    <h5 class="mt-5 subtitle-2">Product Field Options</h5>
                                </td>
                            </tr>
                            <FormField :mapping="formProductMappings.productId" />
                            <FormField :mapping="formProductMappings.parentProductId" />
                            <FormField :mapping="formProductMappings.productGroup" />
                            <FormField :mapping="formProductMappings.orderedQuantity" />
                            <FormField :mapping="formProductMappings.itemPrice" />
                            <FormField :mapping="formProductMappings.packIndividually" />
                            <FormField :mapping="formProductMappings.stackHeightAddition" />
                            <FormField :mapping="formProductMappings.maxStackQuantity" />
                            <FormField :mapping="formProductMappings.additionalSkus" />
                            <FormField :mapping="formProductMappings.componentSkus" />
                            <FormField :mapping="formProductMappings.ignoreProduct" />

                            <tr class="item-row-header mb-3" style="background-color: #fff8dc;">
                                <td colspan="5" class="pt-5">
                                    <h5 class="mt-5 subtitle-2">International Field Options</h5>
                                </td>
                            </tr>
                            <FormField :mapping="formProductMappings.harmonizedCode" />
                            <FormField :mapping="formProductMappings.countryOfManufactureCode"/>
                            <FormField :mapping="formProductMappings.dollarValue" />

                            <tr class="item-row-header mb-3" style="background-color: #fff8dc;">
                                <td colspan="5" class="pt-5">
                                    <h5 class="mt-5 subtitle-2">DG Field Options</h5>
                                </td>
                            </tr>
                            <FormField :mapping="formProductMappings.companyDgItemId" />
                            <FormField :mapping="formProductMappings.aggregateQuantity" />

                        </tbody>
                    </table>

                    <v-row v-if="!is_view">
                        <v-col class="d-flex justify-end">

                            <v-btn @click="onSetDefaultMapping()" small>
                                <span>Set Default</span>
                            </v-btn>

                            <v-btn @click="clearMapping()" small class="ml-2">
                                <span>Clear</span>
                            </v-btn>

                            <v-btn :disabled="isSaving" small type="submit" color="primary" class="ml-2">
                                <span v-if="isSaving">
                                    <v-progress-circular
                                        indeterminate
                                        size="12"
                                        width="2"
                                        color="primary darken-3">
                                    </v-progress-circular>
                                    Saving..
                                </span>
                                <span v-else>Save</span>
                            </v-btn>
                        </v-col>
                    </v-row>

                </v-col>
            </v-container>

        </v-form>
    </div>

</template>
<script>
import { EventBus } from '@/js/event-bus.js'
import { mapGetters, mapActions } from "vuex"
import FormField from './FormField';
import ProductMapper from './ProductMapperStruct';

export default {
    props: {
        id: { type: Number, default: null },
        is_view: { type: Boolean, default: false },
        direction: { type: String, default: '' },
        productMappings: { type: Object, default: {} },
        defaultMappings: { type: Object, default: {} }
    },
    components: {
        FormField
    },

    data() {
        return {
            isSaving: false,
            formProductMappings: {
                ...{

                    // Add fields here

                    //Product Weights, Dimensions & Box Qty
                    sku: new ProductMapper({key: 'sku'}),
                    name: new ProductMapper({key: 'name'}),
                    boxes: new ProductMapper({key: 'boxes'}),
                    itemType: new ProductMapper({key: 'itemType'}),
                    boxQuantity: new ProductMapper({key: 'boxQuantity'}),
                    length: new ProductMapper({key: 'length'}),
                    width: new ProductMapper({key: 'width'}),
                    height: new ProductMapper({key: 'height'}),
                    weight: new ProductMapper({key: 'weight'}),

                    //Product Field Options
                    productId: new ProductMapper({key: 'productId'}),
                    parentProductId: new ProductMapper({key: 'parentProductId'}),
                    productGroup: new ProductMapper({key: 'productGroup'}),
                    orderedQuantity: new ProductMapper({key: 'orderedQuantity'}),
                    itemPrice: new ProductMapper({key: 'itemPrice'}),
                    packIndividually: new ProductMapper({key: 'packIndividually'}),
                    stackHeightAddition: new ProductMapper({key: 'stackHeightAddition'}),
                    maxStackQuantity : new ProductMapper({key: 'maxStackQuantity'}),
                    additionalSkus: new ProductMapper({key: 'additionalSkus'}),
                    componentSkus: new ProductMapper({key: 'componentSkus'}),
                    ignoreProduct: new ProductMapper({key: 'ignoreProduct'}),

                    //International Field Options
                    harmonizedCode: new ProductMapper({key: 'harmonizedCode'}),
                    countryOfManufactureCode: new ProductMapper({key: 'countryOfManufactureCode'}),
                    dollarValue: new ProductMapper({key: 'dollarValue'}),

                    //DG Field Options
                    companyDgItemId: new ProductMapper({key: 'companyDgItemId'}),
                    aggregateQuantity: new ProductMapper({key: 'aggregateQuantity'}),
                },
                ...this.productMappings
            }
        }
    },

    methods: {

        onSetDefaultMapping() {

            //do nothing if there are no default mappings
            if (Object.keys(this.defaultMappings).length === 0) return;

            Object.keys(this.formProductMappings).forEach(field => {
                Object.keys(this.formProductMappings[field]).forEach(fieldKey => {
                    if(this.defaultMappings.hasOwnProperty(field) && this.defaultMappings[field].hasOwnProperty(fieldKey)) {
                        this.formProductMappings[field][fieldKey] = this.defaultMappings[field][fieldKey];
                    } else if(fieldKey !== 'key') {
                        this.formProductMappings[field][fieldKey] = '';
                    }
                });
            });
        },

        clearMapping() {
            Object.keys(this.formProductMappings).forEach(field => {
                Object.keys(this.formProductMappings[field]).forEach(fieldKey => {
                    if (fieldKey !== 'key') {
                        this.formProductMappings[field][fieldKey] = '';
                    }
                });
            });
        },

        onSubmit:_.debounce(function(e) {
            e.preventDefault()

            // require at least product sku or name to be mapped
            const skuMapping = this.formProductMappings['sku'];
            const nameMapping = this.formProductMappings['name'];
            const validSkuMapping = skuMapping.dataSource !== '' && skuMapping.dataSourceValue && skuMapping.dataSourceValue !== '';
            const validNameMapping = nameMapping.dataSource == 'MachShip Field' || (nameMapping.dataSource !== '' && nameMapping.dataSourceValue && nameMapping.dataSourceValue !== '');

            // check if there are any mappings in the form
            const formHasMappings = Object.keys(this.formProductMappings).some(key => {
                const productField = this.formProductMappings[key] && this.formProductMappings[key].dataSource && this.formProductMappings[key].dataSourceValue;
                return this.fieldMappingHasValue(productField);
            });

            if(!validSkuMapping && !validNameMapping && formHasMappings) {
                EventBus.$emit('show-error', 'Please map at least one of the product fields: SKU or Name.')
                return
            }

            if (this.isSaving) return

            const items = [];

            Object.keys(this.formProductMappings).forEach(key => {
                const productField = this.formProductMappings[key];

                // we only need to save the mapping if the field has a value or if it's already mapped and needs to be updated
                if(
                    this.fieldMappingHasValue(productField) ||
                    this.productMappings.hasOwnProperty(key) // if existing mapping we overwrite
                ) {
                    items.push({
                        'data_direction': this.direction,
                        'integration_id': this.id,
                        'machship_field': productField.key || '',
                        'map_type': productField.dataSource || '',
                        'source_field': productField.dataSourceValue || '',
                        'data_conversion_type': productField.castAs || '',
                        'data_conversion_value': productField.castAsValue || ''
                    })
                }
            });

            this.isSaving = true

            this.$http
                .post('/api/fieldmappers/bulk', items)
                .then(({ data }) => {
                    EventBus.$emit('show-success', 'Successfully saved product mapping.')
                })
                .catch(err => {
                    EventBus.$emit('show-error', err)
                })
                .finally(() => {
                    this.isSaving = false
                })

        }, 200),

        fieldMappingHasValue(productField) {

            for (const key of Object.keys(productField)) {
                const inputVal = productField[key] || '';
                if (key !== 'key' && inputVal.trim() !== '') {
                    return true;
                }
            }

            return false
        }
    }
}
</script>